import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 6.35 6.35"
    stroke="currentColor"
    overflow="hidden"
    fill="none"
  >
    <defs>
      <clipPath id="a">
        <path fillRule="evenodd" d="M642 317h57v55h-57z" clipRule="evenodd" />
      </clipPath>
      <clipPath id="b">
        <path fillRule="evenodd" d="M646 233h42v46h-42z" clipRule="evenodd" />
      </clipPath>
    </defs>
    <g
      style={{
        display: "inline",
      }}
    >
      <g
        style={{
          display: "inline",
          overflow: "hidden",
          fill: "none",
          fillOpacity: 1,
          strokeOpacity: 1,
        }}
      >
        <g
          strokeLinecap="round"
          strokeWidth={4}
          clipPath="url(#b)"
          style={{
            fill: "none",
            fillOpacity: 1,
            strokeOpacity: 1,
          }}
          transform="matrix(.14163 0 0 .1426 -91.274 -33.327)"
        >
          <path
            strokeMiterlimit={8}
            d="M650.836 236c2.219 3.713 4.438 7.427 4.136 11.076-.301 3.649-5.558 6.997-5.946 10.818-.387 3.821 3.62 12.106 3.62 12.106v0M665.836 238c2.219 4.15 4.438 8.301 4.136 12.379-.301 4.078-5.558 7.821-5.946 12.091-.387 4.27 3.62 13.53 3.62 13.53v0"
            style={{
              fill: "none",
              fillOpacity: 1,
              strokeOpacity: 1,
            }}
          />
          <path
            strokeLinejoin="round"
            strokeMiterlimit={10}
            d="M680.836 236c2.219 3.713 4.438 7.427 4.136 11.076-.301 3.649-5.558 6.997-5.946 10.818-.387 3.821 3.62 12.106 3.62 12.106v0"
            style={{
              fill: "none",
              fillOpacity: 1,
              strokeOpacity: 1,
            }}
          />
        </g>
        <path
          d="M6.16 38.903a2.092 2.092 0 0 1-.952-.583c-.23-.255-.399-.575-.905-1.714-1.594-3.588-2.716-6.952-3.118-9.349-.189-1.121-.183-2.51.014-3.345.395-1.672 1.085-2.875 3.247-5.654 2.23-2.865 2.569-3.511 2.564-4.878-.008-2.142-.849-4.282-3.337-8.487-.434-.733-.684-1.217-.742-1.437-.228-.862.23-1.812 1.072-2.226.43-.211 1.058-.24 1.512-.07.56.21.83.52 1.607 1.841 2.422 4.12 3.336 6.293 3.75 8.914.095.605.095 2.324 0 2.847-.115.627-.416 1.495-.754 2.171-.51 1.02-1.101 1.87-2.876 4.132-1.523 1.941-2.093 2.955-2.238 3.98-.226 1.59 1.018 5.833 2.958 10.09.582 1.277.632 1.425.632 1.88.001.884-.561 1.621-1.43 1.876a1.736 1.736 0 0 1-1.003.012zM20.94 44.832c-.36-.138-.863-.59-1.033-.928-.07-.14-.303-.691-.519-1.226-1.639-4.07-2.797-7.892-3.183-10.5-.374-2.532-.15-4.124.879-6.22.495-1.01 1.005-1.832 2.167-3.489 2.218-3.164 2.693-4.112 2.765-5.523.072-1.434-.288-3.18-1.06-5.14-.59-1.5-1.025-2.412-2.316-4.867l-.727-1.383v-.552c0-.524.01-.571.188-.9.225-.414.519-.693.94-.89.263-.123.385-.145.808-.145.433 0 .538.02.814.155.555.273.726.5 1.551 2.065 2.172 4.115 3.11 6.505 3.56 9.072.138.787.153 1 .155 2.198 0 1.09-.017 1.41-.101 1.797-.384 1.757-1.069 3.099-2.961 5.801-1.917 2.737-2.381 3.545-2.753 4.787-.15.502-.134 2.03.031 2.957.455 2.544 1.496 5.865 2.998 9.565.437 1.076.46 1.155.458 1.548 0 .334-.032.483-.157.762-.2.445-.671.895-1.108 1.058-.406.152-.996.152-1.395-.002zM36.065 38.875c-.383-.127-.805-.427-1.005-.716-.377-.544-1.898-4.163-2.596-6.175-.939-2.706-1.35-4.512-1.404-6.17-.048-1.446.18-2.49.828-3.787.532-1.066 1.036-1.819 2.25-3.367 2.102-2.683 2.636-3.532 2.825-4.497.046-.234.058-.598.035-1.105-.09-2.05-.948-4.152-3.355-8.22-.324-.548-.624-1.083-.668-1.189-.046-.115-.078-.384-.078-.663 0-.393.024-.522.145-.781.198-.42.476-.714.89-.939.329-.178.376-.188.9-.188.502 0 .582.015.873.162.447.227.662.485 1.296 1.557 2.75 4.647 3.742 7.142 3.933 9.88.181 2.603-.472 4.26-2.913 7.385-1.828 2.34-2.17 2.83-2.612 3.728-.465.945-.538 1.693-.298 3.053.353 1.993 1.463 5.214 2.89 8.376l.585 1.299.003.471c.002.422-.016.509-.177.836-.44.894-1.452 1.347-2.347 1.05z"
          style={{
            fill: "none",
            fillOpacity: 1,
            strokeWidth: 0.0552885,
            strokeOpacity: 1,
          }}
          transform="matrix(.14163 0 0 .1426 .215 -.1)"
        />
      </g>
    </g>
  </svg>
);




